export default __webpack_public_path__ + "static/media/product-5-min.3a34fcc5.jpg";